import React, { useState } from 'react'
import { useServiceRequests } from './ServicesSection'
import { useCandidate } from './CandidateProvider'
import { Button } from '~/lib/ui/button'
import moment from 'moment'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '~/lib/ui/dialog'
import parse from 'html-react-parser'

const ViewCoachFeedbackDialog = ({ children }) => {
  const { detailItemId } = useCandidate()
  const { serviceRequests } = useServiceRequests()
  const currentServiceRequest = serviceRequests?.find(
    (serviceRequest) => serviceRequest.id == detailItemId,
  )
  const [open, setOpen] = useState(false)
  const {
    completedAt,
    message,
    coachDocuments = [],
  } = currentServiceRequest || {}
  const displayCompletedAt = moment(completedAt).format('dddd MMMM Do HH:mm A')

  const formattedMessage = message
    ? parse(message.replace(/\n/g, '<br />'))
    : ''

  return (
    <Dialog
      open={open}
      onOpenChange={() => setOpen(!open)}
      className="rounded-2xl"
    >
      <DialogTrigger asChild className="cursor-pointer">
        <Button
          variant="link"
          className="justify-start font-normal text-intoo-blue-medium hover:text-link"
        >
          {children}
        </Button>
      </DialogTrigger>
      <DialogContent
        className="font-roboto lg:max-w-3xl xl:max-w-5xl"
        variant="default"
        dialogCloseClass="text-black"
      >
        <DialogHeader>
          <DialogTitle className="text-left" asChild>
            <h2 className="text-2xl">Coach Feedback</h2>
          </DialogTitle>
        </DialogHeader>
        <DialogDescription>
          Feedback submitted by coach on {displayCompletedAt}.
        </DialogDescription>
        <div className="px-4 pb-4">
          {coachDocuments.length > 0 && (
            <div className="flex flex-col space-y-2">
              {coachDocuments.map((doc, index) => (
                <a
                  key={index}
                  href={doc.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-intoo-blue-medium hover:underline"
                >
                  {doc.fileName || `Document ${index + 1}`}
                </a>
              ))}
            </div>
          )}
          {message && (
            <div className="mt-4">
              <p className="text-lg font-medium">Message:</p>
              <p className="mt-2">{formattedMessage}</p>
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default ViewCoachFeedbackDialog
